import React, { useContext, useEffect, useState } from 'react';
import { CButton } from '../../../../components/Common';
import { COLORS } from '../../../../constants';
import { useTradeModalStore } from '../../../../hooks/trade/modalStore';
import API from '../../../../../utils/api';
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Input,
  Modal,
  Popover,
  Row,
  Select,
  Space,
  message,
} from 'antd';
import { Input as InputMobile } from 'antd-mobile';

import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../../../../theme/ThemeProvider';
import { useTradePosition } from '../../../../hooks/trade/tradePosition';
import { useOrderBook } from '../../../../hooks/trade/orderBook';
import { useToken } from '../../../../hooks';
import { useExchangeStore } from '../../../../hooks/trade/exchangeStore';
import { useIndexPrice } from '../../../../hooks/trade/indexprice';
import { useLastPrice } from '../../../../hooks/trade/lastprice';
import BigNumber from 'bignumber.js';
import { MView } from '../../../../../styles/mobilePageStyles';
import { Text, View } from '../../../../../styles/reactnative';
import TPSLEDIT from '../TPSLEDIT';
import KrwPrice from '../../../../components/KrwPrice';

import useSound from 'use-sound';
import order from '../../../../../assets/order.mp3';
import { useDisableScroll } from '@utils/useDisableScroll.tsx';
import console from 'node:console';
import { MobileCloseByModal } from '@app/organisms/Trade/TradeDetail/modal/MobileCloseByModal.tsx';
import { USER_LOG_TYPE, useUserLogger } from '@/app/hooks/userLogger';
import useCloseAllStore from '../closeAllStore';


const sleep = (ms: number) => new Promise(res => setTimeout(res, ms));

type Job = () => Promise<void>;
const _q: Job[] = [];
let _draining = false;

async function _drain() {
  if (_draining) return;
  _draining = true;
  while (_q.length) {
    const job = _q.shift()!;
    try {
      await job();
    } catch (e) {
      console.error('close job failed:', e);
    }
    const jitter = 200 + Math.floor(Math.random() * 200);
    await sleep(jitter);
  }
  _draining = false;
}

function enqueue(job: Job) {
  _q.push(job);
  _drain();
}

const ClosedBy = ({
  item,
  closeAll,
  setCloseAll,
  isMobile = false,
  refresh = false,
                    test,
  orderBookValue
}:any) => {
  const { EPs } = useExchangeStore();
  const [EP, setEP] = useState(
    EPs?.find((item2: any) => +item2.id == +item?.exchange_pairs_id)
  );
  const { data: modalStore, mutate: muatateModalStore } = useTradeModalStore();
  const { mutateUserLog, getOrderLog } = useUserLogger();
  const [orderSound] = useSound(order, { volume: 1 });
  const {setFalseClose} = useCloseAllStore();

  useEffect(() => {
    setEP(EPs?.find((item2: any) => +item2.id == +item?.exchange_pairs_id));
  }, [EPs, item]);

  useEffect(() => {

    console.log(`/trade/order danger ${test}`, item, closeAll);
    if (closeAll) {
    setFalseClose();
      
      enqueue(async () => await sendOrder('M', true));
    }
  }, [closeAll]);


  const [open, setOpen] = useState(false);
  const [openMobileClose, setOpenMobileClose] = useState(false);
  const [limit_market, setLimitMarket] = React.useState('L');
  const [amount, setAmount] = React.useState<any>();
  const [selectedPercent, setSelectedPercent] = React.useState<number | null>(null);

  const { getPrice } = useIndexPrice(item?.exchange_pairs_id);
  const { data: lastprice } = useLastPrice(item?.exchange_pairs_id);
  const [closePrice, setClosePrice] = React.useState<any>();

  // 손익금액(pnl) 계산을 위한 상태 추가
  const [calculatedPnl, setCalculatedPnl] = React.useState<any>();

  const [tp, setTp] = React.useState<any>(item?.tpsl?.[0]?.tp || 0);
  const [sl, setSl] = React.useState<any>(item?.tpsl?.[0]?.sl || 0);
  const { data: token } = useToken();
  const { mutate: mutateOrderBook } = useOrderBook(item?.exchange_pairs_id);

  const { mutate: mutatePosition } = useTradePosition();

  const { textw, gray, bgColor, mobileTradeBorder } = React.useContext(ThemeContext).theme.COLORS;
  const { isDarkMode } = useContext(ThemeContext);

  const { t } = useTranslation();

  const { data: tradeModalStore, mutate: mutateTradeModalStore } =
    useTradeModalStore();

  // main_sub 값 가져오기 - 컴포넌트 레벨에서 정의
  const mainSub = localStorage.getItem('main_sub') || 'M';
  
  // 현재 가격 가져오기 - 컴포넌트 레벨에서 정의
  const currentPrice = getPrice(item?.exchange_pairs_id);

  // 컴포넌트 마운트 시 초기 amount 설정
  useEffect(() => {
    // 컴포넌트 마운트 시 1회 실행되어 기본 수량 설정
    if (item?.amount && currentPrice && amount === undefined) {  // amount가 undefined일 때만 초기화
      // 모든 모드에서 동일하게 코인 수량 * 레버리지로 설정
      const coinValue = BigNumber(item?.amount)
        .multipliedBy(item?.leverage)
        .toNumber();


      setAmount(coinValue);

      // 기본적으로 100% 선택 상태로 설정
      setSelectedPercent(1);
    }
  }, [item?.amount, item?.leverage, currentPrice, mainSub]);

  useEffect(() => {
    if(orderBookValue){
      setClosePrice(orderBookValue);
    }
  }, [orderBookValue]);

  // 가격 변경 시 Order by Value 모드일 때 USDT 값 업데이트 (이 부분도 일관되게 처리)
  useEffect(() => {
    if (currentPrice && item?.amount && item?.leverage && selectedPercent) {  // selectedPercent가 있을 때만 업데이트
      // 모든 모드에서 동일하게 코인 수량 * 레버리지 * 선택된 퍼센트로 계산
      const coinValue = BigNumber(item?.amount)
        .multipliedBy(item?.leverage)
        .multipliedBy(selectedPercent)
        .toNumber();


      // amount 상태 업데이트
      setAmount(coinValue);
    }
  }, [currentPrice, mainSub, item?.amount, item?.leverage, selectedPercent]);

  // 추가: 지정가일 때도 손익금액 계산 업데이트
  useEffect(() => {
    if (closePrice || amount) {
      const usedClosePrice = closePrice || getPrice(item?.exchange_pairs_id) || item?.price;
      
      // 모든 모드에서 동일한 계산 방식 사용 (Order By Qty 모드 방식으로 통일)
      const usedAmount = amount || item?.amount * item?.leverage;

      if (limit_market === 'L') {
        // 1. 청산하는 부분의 비율 계산
        const totalAmount = item?.orders?.[0]?.amount || item?.amount;
        const closingRatio = BigNumber(usedAmount)
          .dividedBy(BigNumber(totalAmount).multipliedBy(item?.leverage))
          .toNumber();
        
        // 2. 진입 수수료(엔트리 피)는 청산 비율만큼만 차감
        const entryFee = item?.orders?.[0]?.fee_price || 0;
        const closingEntryFee = BigNumber(entryFee)
          .multipliedBy(closingRatio)
          .toNumber();
        
        // 3. 청산 수수료 계산 (실제로는 백엔드에서 계산될 것임)
        // 여기서는 진입 수수료와 동일한 비율로 예상
        const estimatedExitFee = closingEntryFee;
        
        // 4. PnL 계산: (청산가 - 진입가) * 수량 - 청산부분 진입수수료 - 청산수수료
        const pnlValue = BigNumber(item?.long_short === 'L' ? usedClosePrice : item?.price)
          .minus(item?.long_short === 'L' ? item?.price : usedClosePrice)
          .multipliedBy(usedAmount)
          // .minus(closingEntryFee)
          // .minus(estimatedExitFee)
          .toNumber();

        setCalculatedPnl(pnlValue);
      } else {
        // 시장가 주문일 때 손익금액 계산
        // 1. 청산하는 부분의 비율 계산
        const totalAmount = item?.orders?.[0]?.amount || item?.amount;
        const closingRatio = BigNumber(usedAmount)
          .dividedBy(BigNumber(totalAmount).multipliedBy(item?.leverage))
          .toNumber();
        
        // 2. 진입 수수료(엔트리 피)는 청산 비율만큼만 차감
        const entryFee = item?.orders?.[0]?.fee_price || 0;
        const closingEntryFee = BigNumber(entryFee)
          .multipliedBy(closingRatio)
          .toNumber();
        
        // 3. 청산 수수료 계산 (실제로는 백엔드에서 계산될 것임)
        // 여기서는 진입 수수료와 동일한 비율로 예상
        const estimatedExitFee = closingEntryFee;

        // 4. PnL 계산
        const pnlValue = BigNumber(item?.long_short === 'L' ? getPrice(item?.exchange_pairs_id) || item?.price : item?.price)
          .minus(item?.long_short === 'L' ? item?.price : getPrice(item?.exchange_pairs_id) || item?.price)
          .multipliedBy(usedAmount)
          // .minus(closingEntryFee)
          // .minus(estimatedExitFee)
          .toNumber();
          
        setCalculatedPnl(pnlValue);
      }
    }
  }, [closePrice, amount, limit_market, getPrice, item]);

  const coin = EP?.pairs?.split('/')[0];
  const currency = EP?.pairs?.split('/')[1];
  let pnl = 0;

  if (item?.long_short === 'L') {
    pnl = BigNumber(lastprice?.[0]?.price)
      .minus(item?.price)
      .multipliedBy(item?.amount)
      .multipliedBy(item?.leverage)
      .toNumber();
  } else {
    pnl = BigNumber(item?.price)
      .minus(lastprice?.[0]?.price)
      .multipliedBy(item?.amount)
      .multipliedBy(item?.leverage)
      .toNumber();
  }

  const sendOrder = async (limitmarket, forceAll = false) => {
    try {
      // 컴포넌트 레벨에서 정의된 currentPrice 사용
      
      // 수량 계산 로직
      let checkamount;
      
      // main_sub은 항상 'M'으로 설정 (코인 수량 기준)
      // 백엔드에서는 main_sub='M'일 때 amount를 코인 수량으로 해석합니다
      const orderMainSub = 'M';  // 항상 코인 수량 기준으로 주문
      
      if (forceAll) {
        // closeAll 버튼으로 전체 포지션 청산 시 - 원래 코인 수량 그대로 사용
        checkamount = item?.amount;
      } else {
        // 일반적인 경우(부분 청산)
        if (mainSub === 'S') {
          // UI에서 USDT 가치 모드로 표시하지만, 실제 주문은 코인 수량으로 전송
          if (amount && selectedPercent) {
            // 선택된 퍼센트가 있는 경우 - 코인 수량에 퍼센트 적용
            checkamount = new BigNumber(item?.amount)
              .multipliedBy(selectedPercent)
              // .toFixed(4);
          } else if (amount) {
            // 사용자가 직접 입력한 경우 - USDT 값을 코인 비율로 변환
            // 전체 USDT 가치 계산
            const totalUsdtValue = new BigNumber(item?.amount)
              .multipliedBy(currentPrice)
              .multipliedBy(item?.leverage);
            
            // 입력된 USDT 값이 차지하는 비율 계산
            const ratio = new BigNumber(amount).dividedBy(totalUsdtValue);
            
            // 비율에 따른 코인 수량 계산
            checkamount = new BigNumber(item?.amount)
              .multipliedBy(ratio)
              // .toFixed(4);
              
            // 최소 1%는 사용하도록 보장
            const minAmount = new BigNumber(item?.amount).multipliedBy(0.01).toFixed(4);
            if (new BigNumber(checkamount).isLessThan(minAmount)) {
              checkamount = minAmount;
            }
          } else {
            // amount가 없는 경우(기본값) - 전체 포지션 청산
            checkamount = item?.amount;
          }
        } else {
          // 수량 기준 설정일 때(mainSub === 'M')
          if (amount && selectedPercent) {
            // 퍼센트 버튼을 클릭한 경우 - amount는 이미 코인 수량 * 레버리지 * 퍼센트로 계산됨
            // 백엔드로 보낼 때는 코인 수량으로 변환해야 함 (레버리지 고려하지 않아야 함)
            checkamount = new BigNumber(item?.amount)
              .multipliedBy(selectedPercent)
              // .toFixed(4);
          } else if (amount) {
            // 사용자가 직접 입력한 경우 (amount는 코인 수량 * 레버리지로 표시됨)
            // 레버리지로 나누어 실제 코인 수량 계산
            checkamount = new BigNumber(amount)
              .dividedBy(item?.leverage)
              // .toFixed(4);
              
            // 입력된 양이 전체 포지션보다 크면 전체 포지션으로 제한
            if (new BigNumber(checkamount).isGreaterThan(item?.amount)) {
              checkamount = Number(item?.amount)
                // .toFixed(4);
            }
          } else {
            // amount가 없는 경우(기본값) - 전체 포지션 청산
            checkamount = item?.amount;
          }
        }
      }
      
      // 최소 주문량 확인 (0보다 커야 함)
      // if (new BigNumber(checkamount).isLessThanOrEqualTo(0)) {
      //   message.error(t('invalidOrderAmount'));
      //   return;
      // }
      
      // 주문 수량이 너무 작은지 확인 (최소 포지션의 1%)
      const minOrderAmount = new BigNumber(item?.amount).multipliedBy(0.01).toFixed(4);
      if (new BigNumber(checkamount).isLessThan(minOrderAmount)) {
        message.error(t('minimumOrderAmountRequired'));
        return;
      }

      // 불리한 가격인 경우 시장가로 전환하는 로직 추가
      // 지정가 주문 여부 확인
      const isLimitOrder = limitmarket === 'L';
      
      // 최종 주문 타입 결정
      let finalOrderType = limitmarket;
      
      if (isLimitOrder) {
        // 주문 가격과 현재 가격 비교
        const orderPrice = Number(closePrice || item?.price);
        const currentMarketPrice = Number(getPrice(item?.exchange_pairs_id));
        
        // 불리한 가격인지 확인 (청산은 포지션의 반대 방향이므로 조건이 반대)
        const isPriceUnfavorable = 
          (item?.long_short === 'L' && orderPrice < currentMarketPrice) || // 롱 포지션 청산인데 지정가가 시장가보다 낮음
          (item?.long_short === 'S' && orderPrice > currentMarketPrice);   // 숏 포지션 청산인데 지정가가 시장가보다 높음
        
        // 불리한 가격이면 시장가로 전환
        if (isPriceUnfavorable) {
          finalOrderType = 'M';
          // message.warning('불리한 가격으로 시장가 전환됨');
        }
      }
      
      let usePrice = closePrice;
      if (!usePrice) {
        usePrice = item?.price;
      }
      
      // 나머지 로직은 동일하게 유지...
      const orderParams = {
        ep_id: item?.exchange_pairs_id,
        main_sub: orderMainSub,  // 항상 M으로 설정 (코인 수량 기준)
        long_short: item?.long_short === 'L' ? 'S' : 'L',
        cross_iso: item?.cross_iso,
        leverage: item?.leverage,
        position_id: item?.id,
        reduce_position: 1,
        post_only: 1,
        limit_market: finalOrderType,
        price: usePrice,
        amount: checkamount,
      };

      const result = await API.post('/trade/order', '' + token, orderParams);

      console.log('/trade/order 10');

      if (!modalStore?.sound) {
        orderSound();
      }
      
      if (result?.result?.success) {
        if(forceAll) {
          mutateUserLog({
            log : USER_LOG_TYPE.ORDER_CLOSE_ALL,
            data : orderParams,
          })
        }else {
          mutateUserLog({
            log : getOrderLog(orderParams, USER_LOG_TYPE.ORDER_CLOSE),
            data : orderParams,
          })
        }
        setTimeout(() => {
          mutateOrderBook();
          mutatePosition();
        }, 500);
        message.success(`${t('positionClosedSuccessfully')}`);
      } else {
        if (result?.result?.message) {
          message.error(`${t(result?.result?.message)}`);
        }
      }
    } catch (error) {
      console.error('Order error:', error);
      message.error(t('orderError'));
    }
  };

  useDisableScroll(open);

  const handleTouchMove = (e) => {
    e.stopPropagation();
  };

  // useEffect(() => {
  //   console.log('amount', amount, selectedPercent);
  // }, [amount]);

  // useEffect(() => {
  //   console.log('item', item);
  // }, [item]);

  // 수정: 문자열을 숫자로 변환하고 설정하는 함수 추가
  const handlePriceChange = (e) => {
    // 입력값을 숫자로 변환하여 저장
    const value = e.target.value;
    setClosePrice(value === '' ? null : Number(value));
    
    // 지정가 주문일 때 가격 변경시 손익금액 계산
    if (value !== '' && limit_market === 'L') {
      const usedPrice = Number(value);
      const usedAmount = amount || item?.amount * item?.leverage;
      
      const pnlValue = BigNumber(item?.long_short === 'L' ? usedPrice : item?.price)
        .minus(item?.long_short === 'L' ? item?.price : usedPrice)
        .multipliedBy(usedAmount)
        // .minus(item?.orders?.[0]?.fee_price || 0)
        // .minus(BigNumber(item?.orders?.[0]?.fee_price || 0)
        //   .multipliedBy(item?.orders?.[0]?.amount ?
        //     BigNumber(item.amount).dividedBy(item.orders[0].amount).toNumber() : 1).toNumber())
        .toNumber();
        
      setCalculatedPnl(pnlValue);
    }
  };

  // 수정: Enter 키 누르면 페이지 이동 방지
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  // Input 컴포넌트의 onChange 핸들러 수정
  const handleAmountChange = (e) => {
    const value = e.target.value;
  
    if (value === '') {
      setAmount('');  // 빈 문자열로 설정
      setSelectedPercent(null);  // 퍼센트 선택 초기화
    } else {
      setAmount(value);
      setSelectedPercent(null);  // 사용자가 직접 입력할 경우 선택된 퍼센트 초기화
    }
  };

  return (
    <View style={isMobile ? { width: '100%', flexDirection: 'column' } : {}}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'flex-start',
          borderRadius: isMobile ? 5 : 0,
          backgroundColor: isMobile ? 'bgColor' : 'transparent',
          display: isMobile
            ? item?.tpsl?.length &&
              (item?.tpsl?.[0]?.tp > 0 || item?.tpsl?.[0]?.sl > 0)
              ? 'flex'
              : 'none'
            : 'auto',
          padding: isMobile ? 5 : 0,
          width: '100%',
          maxWidth: !isMobile ? '100%' : '100%',
        }}
      >
        <Modal
          className={'custom-modal'}
          open={open}
          title={t('ordercheck') + ''}
          onCancel={() => {
            setOpen(false);
          }}
          onOk={() => {
            sendOrder(limit_market);
            setOpen(false);
          }}
          cancelText={t('cancel')}
          okText={t('confirm')}
        >
          <div onTouchMove={handleTouchMove}>
            <Divider />
            <Row
              style={{
                borderBottom: '1px solid #efefef',
                padding: '5px 0',
              }}
            >
              <Col span={12}>{t('pairs')}</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {EP?.pairs}
              </Col>
            </Row>

            {isMobile && (
              <Row
                style={{
                  borderBottom: '1px solid #efefef',
                  padding: '5px 0',
                }}
              >
                <Col span={12}>{t('limitmarkets')}</Col>
                <Col span={12} style={{ fontWeight: 'bold' }}>
                  <Space.Compact>
                    <Button
                      size="middle"
                      type={'primary'}
                      style={{
                        opacity: limit_market == 'L' ? 1 : 0.5,
                      }}
                      onClick={() => {
                        setLimitMarket('L');
                      }}
                    >
                      {t('limit')}
                    </Button>
                    <Button
                      type={'primary'}
                      size="middle"
                      style={{
                        opacity: limit_market == 'M' ? 1 : 0.5,
                      }}
                      onClick={() => {
                        setLimitMarket('M');
                      }}
                    >
                      {t('market')}
                    </Button>
                  </Space.Compact>
                </Col>
              </Row>
            )}

            <Row
              style={{
                borderBottom: '1px solid #efefef',
                padding: '5px 0',
              }}
            >
              <Col>
                <div style={{ fontSize: 11 }}>{t('price')}</div>
                {limit_market === 'M' ? (
                  <Input
                    value={t('market')}
                    disabled
                    style={{
                      width: isMobile ? '100%' : 100,
                      fontSize: '1.2rem',
                      border: 0,
                      backgroundColor: bgColor,
                      color: textw,
                    }}
                    size={isMobile ? 'middle' : 'small'}
                  />
                ) : (
                  <Input
                    // defaultValue={item?.price ? item?.price : null}
                    value={closePrice !== null && closePrice !== undefined 
                      ? Number(closePrice).toFixed(EP?.dp || 3) 
                      : item?.price?.toFixed(EP?.dp || 3)}
                    type="number"
                    readOnly
                    style={{
                      width: isMobile ? '100%' : 100,
                      fontSize: '1.2rem',
                      border: 0,
                      backgroundColor: bgColor,
                      color: textw,
                      cursor: 'default',
                    }}
                    size={isMobile ? 'middle' : 'small'}
                    step={parseFloat('0.' + '1'.padStart(EP?.dp || 3, '0'))}
                  />
                )}
              </Col>
              <Col>
                <div style={{ fontSize: 11 }}>
                  {mainSub === 'S' ? t('value') : t('quantity')}
                </div>
                {isMobile ? (
                  <></>
                ) : (
                  <Input
                    defaultValue={amount ? Number(amount).toFixed(4) : Number(item?.amount).toFixed(4)}
                    value={amount}
                    type="number"
                    step={0.001}
                    readOnly
                    style={{
                      width: isMobile ? '100%' : 100,
                      fontSize: '1.2rem',
                      border: 0,
                      backgroundColor: bgColor,
                      color: textw,
                      cursor: 'default',
                    }}
                    size={isMobile ? 'middle' : 'small'}
                  />
                )}
              </Col>
            </Row>
            <Row
              style={{
                borderBottom: '1px solid #efefef',
                padding: '5px 0',
              }}
            >
              <Col span={12}>{t('longshort')}</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {t(item?.long_short === 'L' ? 'long' : 'short')}
              </Col>
            </Row>
            <Row
              style={{
                borderBottom: '1px solid #efefef',
                padding: '5px 0',
              }}
            >
              <Col span={12}>{t('leverage')}</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {t(item?.cross_iso == 'C' ? 'cross' : 'iso')} {item?.leverage}X
              </Col>
            </Row>
            {/*<Row*/}
            {/*  style={{*/}
            {/*    borderBottom: '1px solid #efefef',*/}
            {/*    padding: '5px 0',*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <Col span={12}>{t('margin')}</Col>*/}
            {/*  <Col span={12} style={{ fontWeight: 'bold' }}>*/}
            {/*    {item?.margin} {currency}*/}
            {/*  </Col>*/}
            {/*</Row>*/}
            <Row
              style={{
                borderBottom: '1px solid #efefef',
                padding: '5px 0',
              }}
            >
              <Col span={12}>{t('pnl')}</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {calculatedPnl !== undefined ? (
                  <span style={{ color: calculatedPnl > 0 ? COLORS.lightGreen : calculatedPnl < 0 ? COLORS.lightRed : textw }}>
                    {calculatedPnl.toFixed(4)} {currency}
                  </span>
                ) : (
                  limit_market === 'M'
                    ? (() => {
                      // 시장가: 실시간 가격 사용
                      const marketPrice = getPrice(item?.exchange_pairs_id) ?? item?.price;
                      const entryPrice = item?.price;

                      // 모든 모드에서 동일한 계산 방식 사용 (Order By Qty 모드 방식으로 통일)
                      const usedAmount = amount ?? item?.amount * item?.leverage;

                      const isLong = item?.long_short === 'L';

                      const pnlValue = BigNumber(isLong ? marketPrice : entryPrice)
                        .minus(isLong ? entryPrice : marketPrice)
                        .multipliedBy(usedAmount)
                        .minus(item?.orders?.[0]?.fee_price || 0)
                        .minus(
                          BigNumber(item?.orders?.[0]?.fee_price || 0)
                            .multipliedBy(item?.orders?.[0]?.amount
                              ? BigNumber(item.amount).dividedBy(item.orders[0].amount).toNumber()
                              : 1
                            ).toNumber()
                        )
                        .toNumber();

                      return (
                        <span style={{ color: pnlValue > 0 ? COLORS.lightGreen : pnlValue < 0 ? COLORS.lightRed : textw }}>
                          {pnlValue.toFixed(4)} {currency}
                        </span>
                      );
                    })()
                    : (() => {
                      // 지정가: 유저가 입력한 청산 가격을 closePrice로 넘겨줘야 함
                      const targetPrice = closePrice ?? item?.price;
                      const entryPrice = item?.price;

                      // 모든 모드에서 동일한 계산 방식 사용 (Order By Qty 모드 방식으로 통일)
                      const usedAmount = amount ?? item?.amount;

                      const isLong = item?.long_short === 'L';

                      const pnlValue = BigNumber(isLong ? targetPrice : entryPrice)
                        .minus(isLong ? entryPrice : targetPrice)
                        .multipliedBy(usedAmount)
                        .minus(item?.orders?.[0]?.fee_price || 0)
                        .minus(
                          BigNumber(item?.orders?.[0]?.fee_price || 0)
                            .multipliedBy(item?.orders?.[0]?.amount
                              ? BigNumber(item.amount).dividedBy(item.orders[0].amount).toNumber()
                              : 1
                            ).toNumber()
                        )
                        .toNumber();

                      return (
                        <span style={{ color: pnlValue > 0 ? COLORS.lightGreen : pnlValue < 0 ? COLORS.lightRed : textw }}>
                          {pnlValue.toFixed(4)} {currency}
                        </span>
                      );
                    })()

                )}
              </Col>
            </Row>
            <Row
              style={{
                borderBottom: '1px solid #efefef',
                padding: '5px 0',
              }}
            >
              <Col span={12}>{t('reduceposition')}</Col>
              <Col span={12} style={{ fontWeight: 'bold' }}>
                {'O'}
              </Col>
            </Row>
            {!isMobile && (
              <Checkbox
                style={{ marginTop: 10, color: textw }}
                checked={tradeModalStore?.skip}
                onChange={(e) => {
                  mutateTradeModalStore({
                    ...tradeModalStore,
                    skip: e.target.checked,
                  });
                }}
              >
                {t('notagain')}
              </Checkbox>
            )}
          </div>
        </Modal>
        {!isMobile && (
          <>
            {/*<CButton*/}
            {/*	title={t('limit')}*/}
            {/*	onClick={() => {*/}
            {/*		if (tradeModalStore?.skip) {*/}
            {/*			sendOrder('L')*/}
            {/*		} else {*/}
            {/*			setLimitMarket('L')*/}
            {/*			setOpen(true)*/}
            {/*		}*/}
            {/*	}}*/}
            {/*	style={{*/}
            {/*		background: '#888',*/}
            {/*		color: COLORS.white,*/}
            {/*		fontSize: 10,*/}
            {/*		whiteSpace: 'nowrap',*/}
            {/*		paddingBlock: 5,*/}
            {/*	}}*/}
            {/*/>*/}
            {/*<CButton*/}
            {/*  title={t("market")}*/}
            {/*  onClick={() => {*/}
            {/*    if (tradeModalStore?.skip) {*/}
            {/*      sendOrder("M");*/}
            {/*    } else {*/}
            {/*      setLimitMarket("M");*/}
            {/*      setOpen(true);*/}
            {/*    }*/}
            {/*  }}*/}
            {/*  style={{*/}
            {/*    background: "#666",*/}
            {/*    whiteSpace: "nowrap",*/}
            {/*    color: COLORS.white,*/}
            {/*    fontSize: "1rem",*/}
            {/*    paddingBlock: 5,*/}
            {/*  }}*/}
            {/*/>*/}
          </>
        )}
        {isMobile ? (
          <></>
        ) : (
          // <InputMobile
          // 	defaultValue={item?.price}
          // 	value={closePrice}
          // 	type="number"
          // 	style={{
          // 		width: isMobile ? '100%' : 95,
          // 		color: textw,
          // 		fontSize: '1rem',
          // 		marginLeft: 5,
          // 	}}
          // 	onChange={e => setClosePrice(e)}
          // 	step={parseFloat('0.' + '1'.padStart(EP?.dp || 3, '0'))}
          // />
          <>
            <>
              {/*<Col span={6}>*/}
              {/*  <Button*/}
              {/*    size={"small"}*/}
              {/*    onClick={() => {*/}
              {/*      if (tradeModalStore?.skip) {*/}
              {/*        sendOrder("M");*/}
              {/*      } else {*/}
              {/*        setLimitMarket("M");*/}
              {/*        setOpen(true);*/}
              {/*      }*/}
              {/*    }}*/}
              {/*    style={{*/}
              {/*      background: "#666",*/}
              {/*      whiteSpace: "nowrap",*/}
              {/*      color: COLORS.white,*/}
              {/*      fontSize: "1rem",*/}
              {/*      paddingBlock: 5,*/}
              {/*      border: "none",*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {t("market")}*/}
              {/*  </Button>*/}
              {/*</Col>*/}

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  gap: 10,
                  alignItems: 'flex-end',
                }}
              >
                <div
                  style={{
                    display: 'flex',
                    gap: '2px',
                  }}
                >
                  <Button
                    size={'small'}
                    onClick={() => {
                      if (tradeModalStore?.skip) {
                        sendOrder('M');
                      } else {
                        setLimitMarket('M');
                        setOpen(true);
                      }
                    }}
                    style={{
                      background: 'rgb(102, 102, 102)',
                      whiteSpace: 'nowrap',
                      color: COLORS.white,
                      fontSize: '12px',
                      fontWeight: 700,
                      paddingBlock: 5,
                      border: 'none',
                      borderRadius: 100,
                    }}
                  >
                    {t('market')}
                  </Button>

                  <Button
                    size={'small'}
                    onClick={() => {
                      if (tradeModalStore?.skip) {
                        sendOrder('L');
                      } else {
                        setLimitMarket('L');
                        setOpen(true);
                      }
                    }}
                    style={{
                      background: 'rgb(102, 102, 102)',
                      whiteSpace: 'nowrap',
                      color: COLORS.white,
                      fontSize: '12px',
                      fontWeight: 700,
                      paddingBlock: 5,
                      border: 'none',
                      borderRadius: 100,
                    }}
                  >
                    {t('limit')}
                  </Button>
                </div>

                <Col>
                  <div style={{ fontSize: 11, textAlign: 'center' }}>
                    {t('LiquidationPrice')}
                  </div>
                  <Input
                    defaultValue={closePrice !== null && closePrice !== undefined
                      ? Number(closePrice).toFixed(EP?.dp || 3)
                      : Number(getPrice(item?.exchange_pairs_id) || item?.price).toFixed(EP?.dp || 3)}
                    value={closePrice}
                    type="number"
                    style={{
                      width: isMobile ? '100%' : 100,
                      fontSize: '1.2rem',
                      border: 0,
                      backgroundColor: bgColor,
                      color: textw,
                    }}
                    onChange={handlePriceChange}
                    onKeyDown={handleKeyDown}
                    size={isMobile ? 'middle' : 'small'}
                    step={parseFloat('0.' + '1'.padStart(EP?.dp || 3, '0'))}
                  />
                </Col>

                <Col>
                  <div style={{ fontSize: 11, textAlign: 'center' }}>
                    {/* {mainSub === 'S' ? 'Value' : 'Quantity'} */}
                    {t('quantity')}
                  </div>
                  <Popover
                    content={
                      <Space.Compact size="small">
                        <Button
                          size="small"
                          onClick={() => {
                            if (mainSub === 'S') {
                              // Order by Value: 코인 수량으로 계산하도록 수정
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(item?.leverage)
                                  .multipliedBy(0.25)
                                  .toFixed(4)
                              );
                              setSelectedPercent(0.25);
                            } else {
                              // Order by Quantity: 기존 방식 유지
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(0.25)
                                  .multipliedBy(item?.leverage)
                                  .toFixed(4)
                              );
                              setSelectedPercent(0.25);
                            }
                          }}
                        >
                          25%
                        </Button>
                        <Button
                          size="small"
                          onClick={() => {
                            if (mainSub === 'S') {
                              // Order by Value: 코인 수량으로 계산하도록 수정
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(item?.leverage)
                                  .multipliedBy(0.5)
                                  .toFixed(4)
                              );
                              setSelectedPercent(0.5);
                            } else {
                              // Order by Quantity: 기존 방식 유지
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(0.5)
                                  .multipliedBy(item?.leverage)
                                  .toFixed(4)
                              );
                              setSelectedPercent(0.5);
                            }
                          }}
                        >
                          50%
                        </Button>
                        <Button
                          size="small"
                          onClick={() => {
                            if (mainSub === 'S') {
                              // Order by Value: 코인 수량으로 계산하도록 수정
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(item?.leverage)
                                  .multipliedBy(0.75)
                                  .toFixed(4)
                              );
                              setSelectedPercent(0.75);
                            } else {
                              // Order by Quantity: 기존 방식 유지
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(0.75)
                                  .multipliedBy(item?.leverage)
                                  .toFixed(4)
                              );
                              setSelectedPercent(0.75);
                            }
                          }}
                        >
                          75%
                        </Button>
                        <Button
                          size="small"
                          onClick={() => {
                            if (mainSub === 'S') {
                              // Order by Value: 코인 수량으로 계산하도록 수정
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(item?.leverage)
                                  .toFixed(4)
                              );
                              setSelectedPercent(1);
                            } else {
                              // Order by Quantity: 기존 방식 유지
                              setAmount(
                                BigNumber(item?.amount)
                                  .multipliedBy(item?.leverage)
                                  .toFixed(4)
                              );
                              setSelectedPercent(1);
                            }
                          }}
                        >
                          100%
                        </Button>
                      </Space.Compact>
                    }
                    title=""
                    trigger="click"
                  >
                    {isMobile ? (
                      <></>
                    ) : (
                      // <InputMobile
                      // 	defaultValue={item?.amount}
                      // 	value={amount}
                      // 	type="number"
                      // 	step={0.001}
                      // 	style={{
                      // 		color: textw,
                      // 		width: isMobile ? '100%' : 95,
                      // 		fontSize: '1rem',
                      // 		marginLeft: 5,
                      // 	}}
                      // 	onChange={e => setAmount(e)}
                      // />
                      <Input
                        defaultValue={amount ? Number(amount).toFixed(4) : Number(item?.amount).toFixed(4)}
                        value={amount}
                        type="number"
                        step={0.001}
                        style={{
                          width: isMobile ? '100%' : 100,
                          fontSize: '1.2rem',
                          border: 0,
                          backgroundColor: bgColor,
                          color: textw,
                        }}
                        onChange={handleAmountChange}
                        size={isMobile ? 'middle' : 'small'}
                      />
                    )}
                  </Popover>
                </Col>

              </div>

              {/*<Col span={6}>*/}
              {/*  <Button*/}
              {/*    size={"small"}*/}
              {/*    onClick={() => {*/}
              {/*      if (tradeModalStore?.skip) {*/}
              {/*        sendOrder("L");*/}
              {/*      } else {*/}
              {/*        setLimitMarket("L");*/}
              {/*        setOpen(true);*/}
              {/*      }*/}
              {/*    }}*/}
              {/*    style={{*/}
              {/*      background: "#666",*/}
              {/*      whiteSpace: "nowrap",*/}
              {/*      color: COLORS.white,*/}
              {/*      fontSize: "1rem",*/}
              {/*      paddingBlock: 5,*/}
              {/*      border: "none",*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    {t("limit")}*/}
              {/*  </Button>*/}
              {/*</Col>*/}
            </>

            {/*<Input*/}
            {/*  defaultValue={item?.price}*/}
            {/*  value={closePrice}*/}
            {/*  type="number"*/}
            {/*  style={{*/}
            {/*    width: isMobile ? "100%" : 95,*/}
            {/*    fontSize: "1.1rem",*/}
            {/*    marginLeft: 5,*/}
            {/*    border: 0,*/}
            {/*    backgroundColor: bgColor,*/}
            {/*    color: textw,*/}
            {/*  }}*/}
            {/*  onChange={(e) => setClosePrice(e.target.value)}*/}
            {/*  size={isMobile ? "middle" : "small"}*/}
            {/*  step={parseFloat("0." + "1".padStart(EP?.dp || 3, "0"))}*/}
            {/*/>*/}
          </>
        )}

        {/*<>*/}
        {/*  <CButton*/}
        {/*    title={t("limit")}*/}
        {/*    onClick={() => {*/}
        {/*      if (tradeModalStore?.skip) {*/}
        {/*        sendOrder("L");*/}
        {/*      } else {*/}
        {/*        setLimitMarket("L");*/}
        {/*        setOpen(true);*/}
        {/*      }*/}
        {/*    }}*/}
        {/*    style={{*/}
        {/*      background: "#888",*/}
        {/*      color: COLORS.white,*/}
        {/*      fontSize: 10,*/}
        {/*      whiteSpace: "nowrap",*/}
        {/*      paddingBlock: 5,*/}
        {/*      marginLeft: 3,*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</>*/}

        {/* <TradeText style={{ whiteSpace: 'nowrap', width: 160 }}>
            {useTimezone(item?.created_at)}
        </TradeText> */}
        <MView
          style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            flex: 1,
            width: '100%',
            whiteSpace: 'nowrap',
            marginLeft: 10,
          }}
        >
          <>
            {!isMobile && item?.tpsl?.posId && (
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'flex-start',
                  fontSize: 10,
                  marginRight: 10,
                  marginTop: 10,
                }}
              >
                <Text style={{ fontSize: 13.5 }}>
                  TP: {item?.tpsl?.tp || '-'}
                </Text>
                <Text style={{ fontSize: 13.5 }}>
                  SL: {item?.tpsl?.sl || '-'}
                </Text>
              </View>
            )}
          </>

          <>
            {isMobile && item?.tpsl?.length > 0 && (
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  fontSize: 10,
                  marginRight: 5,
                  width: '100%',
                }}
              >
                <View
                  style={{
                    flexDirection: 'row',
                    flex: 1,
                    width: '100%',
                  }}
                >
                  <Text>
                    TP:{' '}
                    {item?.tpsl?.[0]?.tp
                      ? item?.tpsl?.[0]?.tp + ' ' + currency
                      : '-'}
                  </Text>
                  {item?.tpsl?.[0]?.tp && (
                    <Text
                      style={{
                        marginLeft: 10,
                        paddingInline: 5,
                      }}
                    >
                      (
                      <Text style={{ marginRight: 5 }}>
                        {t('pnlprice') + ': '}
                      </Text>
                      <KrwPrice
                        price={new BigNumber(+item?.price || 1)
                          .minus(+item?.tpsl?.[0]?.tp)
                          .multipliedBy(+item?.amount)
                          .multipliedBy(+item?.leverage)
                          .toNumber()}
                      />
                      )
                    </Text>
                  )}
                </View>
                <View
                  style={{
                    flexDirection: 'row',
                    flex: 1,
                    width: '100%',
                  }}
                >
                  <Text>
                    SL:{' '}
                    {item?.tpsl?.[0]?.sl
                      ? item?.tpsl?.[0]?.sl + ' ' + currency
                      : '-'}
                  </Text>
                  {item?.tpsl?.[0]?.sl && (
                    <Text
                      style={{
                        marginLeft: 10,
                        paddingInline: 5,
                      }}
                    >
                      (
                      <Text style={{ marginRight: 5 }}>
                        {t('pnlprice') + ': '}
                      </Text>
                      <KrwPrice
                        price={new BigNumber(+item?.price || 1)
                          .minus(+item?.tpsl?.[0]?.sl)
                          .multipliedBy(+item?.amount)
                          .multipliedBy(+item?.leverage)
                          .toNumber()}
                      />
                      )
                    </Text>
                  )}
                </View>
              </View>
            )}
          </>

          {/*{!isMobile && (*/}
          {/*  <TPSLEDIT*/}
          {/*    posid={item?.id}*/}
          {/*    tpsl={item?.tpsl?.[0]}*/}
          {/*    price={item?.price}*/}
          {/*    amount={item?.amount}*/}
          {/*    long_short={item?.long_short}*/}
          {/*    leverage={item?.leverage}*/}
          {/*    margin={item?.margin}*/}
          {/*    isMobile={false}*/}
          {/*  />*/}
          {/*)}*/}
        </MView>
      </View>

      {isMobile && (
        <View
          style={{
            width: '100%',
            flexDirection: 'row',
            gap: 3,
            marginTop: 1,
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <TPSLEDIT
            posid={item?.id}
            tpsl={item?.tpsl?.[0]}
            price={item?.price}
            amount={item?.amount}
            long_short={item?.long_short}
            leverage={item?.leverage}
            margin={item?.margin}
            mark={getPrice(item?.exchange_pairs_id)}
            liq={item?.liquid_price}
            exchange_pairs_id={item?.exchange_pairs_id}
            isMobile={true}
          />

          <Button
            onClick={() => {
              setLimitMarket('M');
              setOpenMobileClose(true);
            }}
            style={{
              background: 'transparent',
              border: `1px solid ${mobileTradeBorder}`,
              color: textw,
              minHeight: 30,
            }}
          >{t('closeBy')}</Button>

          <Button
            onClick={() => sendOrder('M', true)}
            style={{
              background: 'transparent',
              border: `1px solid ${mobileTradeBorder}`,
              color: COLORS.lightRed,
              minHeight: 30,
              }}
          >
            {t("quickClose")}
          </Button>

          <MobileCloseByModal sendOrder={sendOrder} open={openMobileClose} setOpen={setOpenMobileClose} data={item} limitMarket={limit_market} setLimitMarket={setLimitMarket} amount={amount} setAmount={setAmount} setSelectedPercent={setSelectedPercent} selectedPercent={selectedPercent} calculatedPnl={calculatedPnl} setCalculatedPnl={setCalculatedPnl} handleAmountChange={handleAmountChange}/>
        </View>
      )}
    </View>
  );
};

export default ClosedBy;